// Log a detailed message for tracing audio processing flow
const LogProcess = async (httpStatus, details = {}) => {
    try {
        const userInfo = JSON.parse(localStorage.getItem("user-info")) || { username: "Unknown", id: "Unknown" };
        const { username, id } = userInfo;

        const timestamp = new Date().toISOString();
        const logLevels = {
            error: console.error,
            warn: console.warn,
            info: console.info
        };

        const logMessage = `${timestamp} :: ${username} with userID ${id} :: VoiceRecognition ${httpStatus.toUpperCase()} Log:`;

        // Ensure the log level exists, fallback to 'info'
        const logFunction = logLevels[httpStatus] || console.info;

        // Automatically handle details as either a string, error object, or generic object
        if (details instanceof Error) {
            // If it's an error object, extract the message and stack trace
            logFunction(logMessage, { message: details.message, stackTrace: details.stack });
        } else {
            // If it's a string or object, just log it as is
            logFunction(logMessage, details);
        }
    } catch (err) {
        console.error("LogProcess encountered an unexpected error:", err);
    }
};

export default LogProcess;


